import { httpGetAsync } from "../../utilities/TZMRequest";

export class VwGrupoProdutoService {

    listarSimples = async (params) => {        
        return await httpGetAsync("/vw-grupo-produtos/listar-simples", params, true);
    }
}
